import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { CustomResult } from "../models/custom-model/customResult.model";
import { DenominationService } from "./../services/denomination.service";

@Injectable()
export class DenominationResolver implements Resolve<CustomResult> {
  constructor(private service: DenominationService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<CustomResult> {
    const id = Number(route.paramMap.get("id"));
    if (id != 0) {
      return this.service.getDenominationById(+id);
    } else {
      return null;
    }
  }
}
